import React from 'react';
import { AdProductGroup } from '@models/account';
import { useSearchParams } from 'react-router-dom';
import AdspRegistrationPage from 'src/pages/adspRegistration/page';
import RegistrationPage from 'src/pages/registration/page';
import RetailerAccountRegistrationPage from 'src/pages/retailerAccountRegistration/page';

/**
 * We have two registration views: one for SAR and one for PLD registration.
 * Checks if the /registration endpoint has the query parameter 'invitationToken' and loads the appropriate component accordingly.
 */
const RegistrationRouter = () => {
  const [searchParams] = useSearchParams();
  const invitationToken = searchParams.get('invitationToken');
  const registrationProgram = searchParams.get('adProductGroup');

  if (registrationProgram?.toUpperCase() === AdProductGroup.ADSP) {
    return <AdspRegistrationPage />;
  }

  return invitationToken ? (
    <RetailerAccountRegistrationPage invitationToken={invitationToken} />
  ) : (
    <RegistrationPage />
  );
};

export default RegistrationRouter;
